import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { ReportInstance } from 'domain/entity/reportInstance';

const readReportInstancesApiClient = getArrayApiClient(() => `dashboards/reports`, ReportInstance);

export default readReportInstancesApiClient;
